export const Types = {
  OPEN_HELP: '@help/OPEN_HELP',
  CLOSE_HELP: '@help/CLOSE_HELP',
};

export function openHelp() {
  return {
    type: Types.OPEN_HELP,
  };
}

export function closeHelp() {
  return {
    type: Types.CLOSE_HELP,
  };
}
